import { Input } from '@weareopenr/component-library';
import { UseFormReturn } from 'react-hook-form';
import { usePriceSchemes } from '../../hooks/usePriceSchemes';

export const PriceSchemeNameInput = ({ formFields }: { formFields: UseFormReturn<any> }) => {
  const {
    register,
    formState: { errors },
  } = formFields;
  const { data = [] } = usePriceSchemes();

  const error = errors['name']?.message.toString() ?? undefined;

  return (
    <Input
      type="text"
      label="Name your scheme"
      hasMargin
      register={register('name', {
        required: true,
        maxLength: 255,
        validate: {
          greaterThanZero: (v) => v.trim().length > 0,
          isUnique: (v: string) => {
            const matchingPriceScheme = data.some(
              (priceScheme) => v.toLocaleLowerCase() === priceScheme.name.toLocaleLowerCase(),
            );
            if (matchingPriceScheme) return 'Price scheme already exists';
            return true;
          },
        },
      })}
      error={error}
    />
  );
};
